import _ from "lodash";

export function mapRange(
  value: number,
  sourceRange: [number, number],
  targetRange: [number, number]
): number {
  const [sourceMin, sourceMax] = sourceRange;
  const [targetMin, targetMax] = targetRange;

  if (value < sourceMin) {
    value = sourceMin;
  } else if (value > sourceMax) {
    value = sourceMax;
  }

  const sourceSpan = sourceMax - sourceMin;
  const targetSpan = targetMax - targetMin;

  const scaledValue = (value - sourceMin) / sourceSpan;
  return targetMin + scaledValue * targetSpan;
}
